import React from "react";
import { arrayOf, func, number, shape, string } from "prop-types";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";

import * as utilsI18n from "util/i18n";
import { getLastLoginDate, getLastLoginPlace } from "util/settings";
import Avatar from "./Avatar";
import Button from "./Button";
import Dropdown from "./Dropdown";
import UserLink from "./UserLink";

function Profile({ loggedUser, logout }) {
    function getLastLoginInfo() {
        if (loggedUser) {
            const { previousLoginInfo } = loggedUser;

            if (previousLoginInfo && previousLoginInfo.length) {
                return (
                    <section className="px-5">
                        <p className="ellipsis bold m-0">{utilsI18n.get("settings.lastLogin.date")}</p>
                        <p className="ellipsis tiny-small mt-2 mb-6">
                            {getLastLoginDate(previousLoginInfo[0])}
                            <span className="text-lowercase">
                                &nbsp;{utilsI18n.get("settings.lastLogin.from")}&nbsp;
                            </span>
                            <Link to="/settings/lastLogin">{getLastLoginPlace(previousLoginInfo[0])}</Link>
                        </p>
                    </section>
                );
            }
        }
        return null;
    }
    const dispatch = useDispatch();

    return (
        <Dropdown
            buttonClass="header-dropdown-button profile"
            dropdownButtonContent={
                <>
                    <Avatar user={loggedUser} />
                    <span className="avatar-text avatar-tag pl-0 pr-7">{utilsI18n.get("menu.settings")}</span>
                </>
            }
            pullRightBottom>
            <UserLink loggedUser={loggedUser} />
            {getLastLoginInfo()}
            <section>
                <Button
                    block
                    bsStyle="link"
                    className="btn-small justify-content-start px-5 regular"
                    onClick={() => dispatch(push("/settings"))}
                    label="settings.index"
                />
                <Button
                    block
                    bsStyle="link"
                    className="btn-small justify-content-start mt-0 px-5 regular"
                    onClick={logout}
                    label="global.logout"
                />
            </section>
        </Dropdown>
    );
}

Profile.propTypes = {
    logout: func,
    loggedUser: shape({
        accessToken: string,
        defaultAvatarId: string,
        email: string,
        previousLoginInfo: arrayOf(
            shape({
                city: string,
                country: string,
                date: string,
                idUser: string,
                ip: string,
                latitude: number,
                longitude: number,
            }),
        ),
        securitySeal: number,
        userFullName: string,
    }),
    previousLoginInfo: arrayOf(
        shape({
            city: string,
            country: string,
            date: string,
            idUser: string,
            ip: string,
            latitude: number,
            longitude: number,
        }),
    ),
};

Profile.defaultProps = {
    logout: () => {},
    loggedUser: null,
    previousLoginInfo: null,
};

export default Profile;
